import { render, staticRenderFns } from "./ProducerOldDebtsImportModal.vue?vue&type=template&id=ade8b390&scoped=true"
import script from "./ProducerOldDebtsImportModal.vue?vue&type=script&lang=js"
export * from "./ProducerOldDebtsImportModal.vue?vue&type=script&lang=js"
import style0 from "./ProducerOldDebtsImportModal.vue?vue&type=style&index=0&id=ade8b390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade8b390",
  null
  
)

export default component.exports